import { Button } from 'primereact/button'
import React from 'react'
import { useTranslation } from 'react-i18next'
import PaymentIcons from 'src/components/PaymentIcons/PaymentIcons'
import PrintButton from 'src/components/PrintButton/PrintButton'

interface InvoiceFooterProps {
  showPayButton: boolean;
  contentRef: React.RefObject<HTMLDivElement>;
  payInvoiceHandler: () => void;
}

const InvoiceFooter: React.FC<InvoiceFooterProps> = ({ showPayButton, contentRef, payInvoiceHandler }) => {
    const { t } = useTranslation(["common"]);

  return (
    <div
    className={`d-flex align-items-center invoice-details-footer ${
      showPayButton ? "justify-content-between" : "justify-content-start"
    }`}
  >
    <PrintButton contentRef={contentRef} />

    {showPayButton && (
      <div className="d-flex gap-3 align-items-center">
        <PaymentIcons />
        <Button
          label={t("payNow")}
          onClick={payInvoiceHandler}
          className="primary-btn d-flex m-0 next-btn p-2"
        ></Button>
      </div>
    )}
  </div>
  )
}

export default InvoiceFooter